module.exports = "/assets/766ff16f6e0f4d84663347c28fa0ef83.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/HU.png
// module id = 1452
// module chunks = 0